import React, { useEffect, useState, useRef, useCallback } from 'react';
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
// import LocationPicker from '../../components/Map/LocationPicker';
import img2 from '../../assest/loading1.gif'
import { formatDate1 } from '../../utils/utils';

import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

const ReOrder = () => {
    const navigate = useNavigate()
    const { id, userid } = useParams()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState([])
    const [subcategory, setSubCategory] = useState([])
    const [subcategorychild, setSubCategoryChild] = useState([])
    const [outfit, setOutfit] = useState([])
    const [products, setProducts] = useState([])
    const [cartcount, setCartCount] = useState(null)
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [loading5, setLoading5] = useState(false);
    const [loading6, setLoading6] = useState(false);

    const [formData, setFormData] = useState({
        outfits: [],
        equipment: [],
        contactName: '',
        phone: '',
        mobility: [],
        description: '',
        pinCode: '',
        parkingAccess: '',
        name: '',
        address: '',
        country: '',
        state: '',
        city: '',
        invoiceName: '',
        invoiceAddress: '',
        invoicePinCode: '',
        invoiceCity: '',
        invoiceCountry: '',
        companyRegistrationNumber: '',
        invoiceDetails: '',
        location: {
            type: "Point",
            coordinates: [],
        },
    });
    const defaultJob = {
        category: '',
        subCategoryId: '',
        subCategoryTimeId: '',
        date: '',
        toTime: '',
        fromTime: '',
        workingHours: 0,
        pax: 0,
        totalMin: 0,
        totalTime: '',
        price: 0,
        forStaffPrice: 0,
        productId: '',
        quantity: 0,
        kids: 0,
        adults: 0,
        isProduct: false
    };



    const [jobInputs, setJobInputs] = useState([defaultJob]);



    const fetchOrderData = useCallback(async () => {
        await getApi(endPoints.getorderbyid(id), {
            setResponse: (response) => {
                const data = response?.data || {};
                const allBooking = data?.allBookingId || {};
                const jobs = data?.jobs || [];

                // Set form data from allBooking
                setFormData({
                    outfits: allBooking?.outfits || [],
                    equipment: allBooking?.equipment || [],
                    contactName: allBooking?.contactName || '',
                    phone: allBooking?.phone || '',
                    mobility: allBooking?.mobility || [],
                    description: allBooking?.description || '',
                    pinCode: allBooking?.pinCode || '',
                    parkingAccess: allBooking?.parkingAccess || '',
                    name: allBooking?.name || '',
                    address: allBooking?.address || '',
                    country: allBooking?.country || '',
                    state: allBooking?.state || '',
                    city: allBooking?.city || '',
                    invoiceName: allBooking?.invoiceName || '',
                    invoiceAddress: allBooking?.invoiceAddress || '',
                    invoicePinCode: allBooking?.invoicePinCode || '',
                    invoiceCity: allBooking?.invoiceCity || '',
                    invoiceCountry: allBooking?.invoiceCountry || '',
                    companyRegistrationNumber: allBooking?.companyRegistrationNumber || '',
                    invoiceDetails: allBooking?.invoiceDetails || '',
                    location: allBooking?.location || {
                        type: "Point",
                        coordinates: [],
                    },
                });

                // Map jobs to jobInputs format
                const mappedJobs = jobs.flatMap(job => {
                    return job.subCategories.map(subJob => {
                        const isProductJob = subJob.product && subJob.product.length > 0;

                        const baseJob = {
                            category: job.category?._id || '',
                            subCategoryId: subJob.subCategoryId?._id || '',
                            date: job.date ? formatDate1(job.date, 'yyyy-MM-dd') : '',
                            toTime: subJob.toTime || '',
                            fromTime: subJob.fromTime || '',
                            workingHours: subJob.workingHours || 0,
                            pax: subJob.pax || 0,
                            totalMin: subJob.totalMin || 0,
                            totalTime: subJob.totalTime || '',
                            price: subJob.price || 0,
                            forStaffPrice: subJob.forStaffPrice || 0,
                            isProduct: isProductJob
                        };


                        if (isProductJob) {
                            const product = subJob.product[0];
                            return {
                                ...baseJob,
                                productId: product.productId?._id || '',
                                quantity: product.quantity || 0,
                                productName: product.productId?.name || '',
                                productPrice: product.price || 0
                            };
                        }

                        return {
                            ...baseJob,
                            kids: subJob.kids || 0,
                            adults: subJob.adults || 0
                        };
                    });
                });

                setJobInputs(mappedJobs.length > 0 ? mappedJobs : [defaultJob]);
            },
            setLoading: setLoading5,
            errorMsg: 'Failed to fetch order data!',
        });
    }, [id]);


    console.log(defaultJob.subCategoryId, "jlajdl")

    useEffect(() => {
        fetchOrderData();
    }, [fetchOrderData]);


    const handleJobChange = (index, e) => {
        const { name, value } = e.target;

        setJobInputs((prevJobs) => {
            const updatedJobs = [...prevJobs];
            let updatedJob = { ...updatedJobs[index], [name]: value };

            // Handle subCategoryTimeId selection
            if (name === "subCategoryTimeId") {
                const selectedSubCategory = subcategorychild?.data?.find(
                    (cat) => cat._id === value
                );
                if (selectedSubCategory) {
                    updatedJob = {
                        ...updatedJob,
                        totalMin: selectedSubCategory.totalMin,
                        totalTime: selectedSubCategory.totalTime,
                        price: selectedSubCategory.price,
                        forStaffPrice: selectedSubCategory.forStaffPrice,
                        workingHours: selectedSubCategory.totalMin / 60,
                    };

                    // If fromTime is already selected, auto-calculate toTime
                    if (updatedJob.fromTime) {
                        const fromTime = new Date(`2000-01-01T${updatedJob.fromTime}`);
                        const toTime = new Date(fromTime.getTime() + selectedSubCategory.totalMin * 60000);
                        updatedJob.toTime = toTime.toTimeString().substring(0, 5);
                    }
                }
            }

            // Handle fromTime selection
            if (name === "fromTime") {
                if (updatedJob.totalMin) {
                    const fromTime = new Date(`2000-01-01T${value}`);
                    const toTime = new Date(fromTime.getTime() + updatedJob.totalMin * 60000);
                    updatedJob.toTime = toTime.toTimeString().substring(0, 5);
                }
            }

            // Handle category change - reset subcategory and subcategorychild
            if (name === "category") {
                updatedJob = {
                    ...updatedJob,
                    subCategoryId: '',
                    subCategoryTimeId: '',
                    totalMin: 0,
                    totalTime: '',
                    price: 0,
                    forStaffPrice: 0,
                    workingHours: 0,
                    toTime: '',
                };
            }

            // Handle subCategoryId change - reset subcategorychild
            if (name === "subCategoryId") {
                updatedJob = {
                    ...updatedJob,
                    subCategoryTimeId: '',
                    totalMin: 0,
                    totalTime: '',
                    price: 0,
                    forStaffPrice: 0,
                    workingHours: 0,
                    toTime: '',
                };
            }

            updatedJobs[index] = updatedJob;
            return updatedJobs;
        });

        // Fetch subcategories when category changes
        if (name === "category") {
            fetchSubCategoryData(value);
        }

        // Fetch subcategory children when subcategory changes
        if (name === "subCategoryId") {
            const categoryId = jobInputs[index].category;
            if (categoryId && value) {
                fetchSubCategoryChildData(categoryId, value);
            }
        }
    };



    const handleChange = (e) => {
        if (Array.isArray(e)) {
            setFormData((prev) => ({ ...prev, outfits: e.map(item => item.value) }));
        } else {
            const { name, value } = e.target;
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };


    const handleLocationSelect = (latLng) => {
        setFormData((prev) => ({
            ...prev,
            location: {
                type: "Point",
                coordinates: [latLng.lng, latLng.lat], // Store longitude, latitude
            },
        }));
    };


    const addJob = () => {
        setJobInputs(prev => [...prev, { ...defaultJob }]);
    };

    const removeJob = (index) => {
        if (jobInputs.length > 1) {
            setJobInputs(prev => prev.filter((_, i) => i !== index));
        }
    };

    const handleAddCart = async (index) => {
        const jobPayload = { ...jobInputs[index] };
        await postApi(endPoints.addOrder(userid), jobPayload, {
            successMsg: 'Item successfully added to cart!',
            errorMsg: 'Unable to add item to cart. Please try again.',
            setLoading: setLoading6,
            additionalFunctions: [
                () => setCartCount(prev => prev + 1),
                () => {
                    setJobInputs(prev => {
                        const newJobs = [...prev];
                        newJobs[index] = defaultJob;
                        return newJobs;
                    })
                }
            ],
        });
    };



    const handleSubmit = async () => {
        const orderPayload = { ...formData };
        await postApi(endPoints.addOrder1(userid), orderPayload, {
            successMsg: 'Order created successfully!',
            errorMsg: 'Failed to add jobs!',
            setLoading: setLoading,
            additionalFunctions: [
                () => {
                    setShow(true);
                    setTimeout(() => {
                        setShow(false);
                        navigate(`/user-management/create-order/cart/${userid}`);
                    }, 2000);
                },
            ],
        });
    };



    const fetchData = async () => {
        await getApi(endPoints.getallcategory, {
            setResponse: setCategory,
            setLoading: setLoading1,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };

    const fetchSubCategoryData = async (categoryId) => {
        if (!categoryId) return;
        await getApi(endPoints.getallsubcategorybycategory(categoryId), {
            setResponse: setSubCategory,
            setLoading: setLoading2,
        });
    };
    const fetchSubCategoryChildData = async (categoryId, subCategoryId) => {
        if (!categoryId || !subCategoryId) return;
        await getApi(endPoints.getallsubcategorychildbycategory(categoryId, subCategoryId), {
            setResponse: setSubCategoryChild,
            setLoading: setLoading3,
        });
    };

    const fetchOutfitData = async () => {
        await getApi(endPoints.getalldress1, {
            setResponse: setOutfit,
            setLoading: setLoading4,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };
    const fetchProductData = async () => {
        await getApi(endPoints.getallproducts, {
            setResponse: setProducts,
            setLoading: setLoading6,
            // errorMsg: 'Failed to fetch jobs!'
        });
    };


    useEffect(() => {
        fetchData();
        fetchOutfitData();
        fetchProductData();
    }, []);

    useEffect(() => {
        if (jobInputs.category) {
            fetchSubCategoryData(jobInputs.category); // Pass categoryId here
        } else {
            setSubCategory([]); // Clear subcategories when no category is selected
            setSubCategoryChild([]); // Also clear subcategory children
        }
    }, [jobInputs.category]);

    useEffect(() => {
        if (jobInputs.category && jobInputs.subCategory) {
            fetchSubCategoryChildData(jobInputs.category, jobInputs.subCategory);
        } else {
            setSubCategoryChild([]);
        }
    }, [jobInputs.category, jobInputs.subCategory]);




    const equipmentOptions = [
        { value: 'BOTTLE OPENER', label: 'BOTTLE OPENER' },
        { value: 'TOOLBOX', label: 'TOOLBOX' },
        { value: 'EQUIPMENT', label: 'EQUIPMENT' },
    ];

    const mobilityOptions = [
        { value: 'This Job Requires a Driving License', label: 'Driving License Required' },
        { value: 'The Professionals will have to use their own Vehicle', label: 'Own Vehicle Required' },
        { value: 'This Job Requires a Bar License', label: 'Bar License Required' },
    ];






    const MultiSelectCheckbox = ({
        options,
        selectedValues,
        onSelect,
        onRemove,
        placeholder,
        searchable = false
    }) => {
        const [isOpen, setIsOpen] = useState(false);
        const [tempSelections, setTempSelections] = useState([]);
        const [searchTerm, setSearchTerm] = useState("");
        const wrapperRef = useRef(null);

        useEffect(() => {
            if (isOpen) {
                setTempSelections(selectedValues || []);
            }
        }, [isOpen]);

        const filteredOptions = searchable
            ? options?.filter(option =>
                (option.label || option.name || "").toLowerCase().includes(searchTerm.toLowerCase())
            )
            : options;

        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        useEffect(() => {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);

        const handleTempSelect = (value) => {
            setTempSelections(prev =>
                prev.includes(value)
                    ? prev.filter(v => v !== value)
                    : [...prev, value]
            );
        };

        const applySelections = () => {
            const toAdd = tempSelections?.filter(v => !(selectedValues || []).includes(v));
            const toRemove = (selectedValues || []).filter(v => !tempSelections.includes(v));

            toAdd.forEach(value => onSelect(value));
            toRemove.forEach(value => onRemove(value));

            setIsOpen(false);
        };

        const cancelSelections = () => {
            setTempSelections(selectedValues || []);
            setIsOpen(false);
        };

        const toggleSelectAll = () => {
            if (tempSelections.length === filteredOptions.length) {
                setTempSelections([]);
            } else {
                setTempSelections(filteredOptions.map(opt => opt.value || opt.name));
            }
        };

        return (
            <div className={addjob.multiSelectWrapper} ref={wrapperRef}>
                <div className={addjob.selectInput} onClick={() => setIsOpen(!isOpen)}>
                    {placeholder}
                    <span className={addjob.arrowIcon}>{isOpen ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}</span>
                </div>

                {isOpen && (
                    <div className={addjob.dropdown}>
                        {searchable && (
                            <div className={addjob.searchBox}>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        )}

                        <div className={addjob.selectAllContainer}>
                            <button
                                type="button"
                                onClick={toggleSelectAll}
                                className={addjob.selectAllButton}
                            >
                                {tempSelections.length === filteredOptions.length ? 'Deselect All' : 'Select All'}
                            </button>
                        </div>

                        <div className={addjob.optionsContainer}>
                            {filteredOptions.map(option => (
                                <h6 key={option.value || option.name} className={addjob.optionItem}>
                                    <input
                                        type="checkbox"
                                        checked={tempSelections.includes(option.value || option.name)}
                                        onChange={() => handleTempSelect(option.value || option.name)}
                                    />
                                    {option.label || option.name}
                                </h6>
                            ))}
                        </div>

                        <div className={addjob.dropdownFooter}>
                            <button type="button" className={addjob.cancelButton} onClick={cancelSelections}>
                                Cancel
                            </button>
                            <button type="button" className={addjob.applyButton} onClick={applySelections}>
                                Apply ({tempSelections.length})
                            </button>
                        </div>
                    </div>
                )}

                <div className={addjob.selectedTags}>
                    {(selectedValues || []).map((value) => {
                        const option = options?.find(opt => opt.value === value || opt.name === value);
                        return (
                            <div key={value} className={addjob.tag}>
                                <span>{option?.label || option?.name}</span>
                                <button
                                    type="button"
                                    className={addjob.removeBtn}
                                    onClick={() => onRemove(value)}
                                >
                                    ×
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };





    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Added"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Re-Order</h6>
                    </div>
                </div>
                {loading5 ? (
                    <div className={addjob.loadingnormal}>
                        <img src={img2} alt="Loading" width={100} height={100} />
                    </div>
                ) : (
                    <div className={addjob.addjobcontainer}>
                        <div className={addjob.addjobsubcontainer}>
                            <div className={addjob.addjobtopic}>
                                <h6>Add Order Details</h6>
                            </div>

                            {jobInputs.map((job, index) => (
                                <div className={addjob.addcontactdetails} key={index}>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="category">Select Category</label>
                                        <select
                                            name="category"
                                            value={job.category}
                                            onChange={(e) => handleJobChange(index, e)}
                                        >
                                            <option value="">Select Category</option>
                                            {loading1 ?
                                                <option value="">Loading...</option>
                                                :
                                                category?.data?.length === 0 ?
                                                    <option value="">No data</option>
                                                    :
                                                    category?.data?.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat.name}
                                                        </option>
                                                    ))}
                                        </select>
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="">Select Subcategory</label>
                                        <select
                                            name="subCategoryId"
                                            value={job.subCategoryId}
                                            onChange={(e) => handleJobChange(index, e)}
                                            disabled={!job.category}
                                        >
                                            <option value="">Select SubCategory</option>
                                            {loading2 ?
                                                <option value="">Loading...</option>
                                                :
                                                subcategory?.data?.length === 0 ?
                                                    <option value="">No data</option>
                                                    :
                                                    subcategory?.data?.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat.name}
                                                        </option>
                                                    ))}
                                        </select>
                                    </div>
                                    {job.isProduct ? (
                                        <>
                                            <div className={addjob.addjobinputs}>
                                                <label htmlFor="">Select Product</label>
                                                <select
                                                    name="productId"
                                                    value={job.productId}
                                                    onChange={(e) => handleJobChange(index, e)}
                                                >
                                                    <option value="">Select Product</option>
                                                    {loading6 ?
                                                        <option value="">Loading...</option>
                                                        :
                                                        products?.data?.length === 0 ?
                                                            <option value="">No data</option>
                                                            :
                                                            products?.data?.map((cat) => (
                                                                <option key={cat._id} value={cat._id}>
                                                                    {cat.name}
                                                                </option>
                                                            ))}
                                                </select>
                                            </div>
                                            <div className={addjob.addjobinputs}>
                                                <label htmlFor="quantity">Quantity</label>
                                                <input
                                                    type="number"
                                                    name="quantity"
                                                    value={job.quantity}
                                                    onChange={(e) => handleJobChange(index, e)}
                                                />
                                            </div>
                                            <div className={addjob.addjobinputs}>
                                                <label htmlFor="kids">Kids</label>
                                                <input
                                                    type="number"
                                                    name="kids"
                                                    value={job.kids}
                                                    onChange={(e) => handleJobChange(index, e)}
                                                />
                                            </div>
                                            <div className={addjob.addjobinputs}>
                                                <label htmlFor="adults">Adults</label>
                                                <input
                                                    type="number"
                                                    name="adults"
                                                    value={job.adults}
                                                    onChange={(e) => handleJobChange(index, e)}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className={addjob.addjobinputs}>
                                                <label htmlFor="pax">How Many Pax</label>
                                                <input
                                                    type="number"
                                                    placeholder="Enter the pax"
                                                    name="pax"
                                                    value={job.pax}
                                                    onChange={(e) => handleJobChange(index, e)}
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="date">Date</label>
                                        <input
                                            type="date"
                                            name="date"
                                            value={job.date}
                                            onChange={(e) => handleJobChange(index, e)}
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="subCategoryTimeId">Working Hours</label>
                                        <select
                                            name="subCategoryTimeId"
                                            value={job.subCategoryTimeId}
                                            onChange={(e) => handleJobChange(index, e)}
                                        >
                                            <option value="">Select Hours</option>
                                            {loading3 ? (
                                                <option value="">Loading...</option>
                                            ) : subcategorychild?.data?.length === 0 ? (
                                                <option value="">No data</option>
                                            ) : (
                                                subcategorychild?.data?.map((cat) => (
                                                    <option key={cat._id} value={cat._id}>
                                                        {cat.totalTime}
                                                    </option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="fromTime">Start Time</label>
                                        <input
                                            type="time"
                                            name="fromTime"
                                            value={job.fromTime?.split("T")[1]?.slice(0, 5) || ""}
                                            onChange={(e) => handleJobChange(index, e)}
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="toTime">End Time</label>
                                        <input
                                            type="time"
                                            name="toTime"
                                            value={job.toTime.split("T")[1]?.slice(0, 5) || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="btn"> Click "Add" button to add to Cart</label>
                                        <div className={addjob.rightbuttons}>
                                            <button
                                                onClick={() => handleAddCart(index)}
                                                style={{ background: '#F05423' }}
                                                disabled={loading6}
                                            >
                                                {loading6 ? "Adding..." : "Add"}
                                                <span style={{ marginLeft: "5px" }}>({cartcount})</span>
                                            </button>
                                            {jobInputs.length > 1 && (
                                                <button
                                                    onClick={() => removeJob(index)}
                                                    style={{ background: '#ff4444', marginLeft: '10px' }}
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}


                            <div className={addjob.addjobinputs}>
                                <button
                                    type="button"
                                    onClick={addJob}
                                    className={addjob.addMoreButton}
                                >
                                    + Add Another Job
                                </button>
                            </div>

                            {/* The rest of the form (outfits, equipment, contact details, etc.) */}
                            {/* ... Same as in CreateOrder component ... */}

                            <div className={addjob.addjobtopic}>
                                <h6>Add Other Details</h6>
                            </div>
                            <div className={addjob.addcontactdetails}>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Outfit</label>
                                    <MultiSelectCheckbox
                                        options={outfit.data}
                                        selectedValues={formData.outfits}
                                        onSelect={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                outfits: [...(prev.outfits || []), value]
                                            }))
                                        }
                                        onRemove={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                outfits: prev.outfits.filter(v => v !== value)
                                            }))
                                        }
                                        placeholder="Select outfits..."
                                        searchable
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Equipment</label>
                                    <MultiSelectCheckbox
                                        options={equipmentOptions}
                                        selectedValues={formData.equipment}
                                        onSelect={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                equipment: [...(prev.equipment || []), value]
                                            }))
                                        }
                                        onRemove={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                equipment: prev.equipment.filter(v => v !== value)
                                            }))
                                        }
                                        placeholder="Select equipment..."
                                        searchable
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Select Mobility</label>
                                    <MultiSelectCheckbox
                                        options={mobilityOptions}
                                        selectedValues={formData.mobility}
                                        onSelect={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                mobility: [...(prev.mobility || []), value]
                                            }))
                                        }
                                        onRemove={(value) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                mobility: prev.mobility.filter(v => v !== value)
                                            }))
                                        }
                                        placeholder="Select mobility requirements..."
                                        searchable
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Contact Name</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the contact name'
                                        name="contactName"
                                        value={formData.contactName}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Name</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the name'
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Contact Phone</label>
                                    <input
                                        type="number"
                                        placeholder='Enter the contact number'
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Parking Access</label>
                                    <select value={formData.parkingAccess}
                                        name="parkingAccess"
                                        onChange={handleChange} >
                                        <option value="">Select</option>
                                        <option value="Free Parking">Free Parking</option>
                                        <option value="Paid Parking">Paid Parking</option>
                                    </select>
                                </div>

                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Address</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the address'
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Country</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the country'
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">State</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the state'
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">City</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the city'
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">PinCode</label>
                                    <input
                                        type="number"
                                        placeholder='Enter the pincode'
                                        name="pinCode"
                                        value={formData.pinCode}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Order Description</label>
                                <textarea placeholder='description'
                                    value={formData.description}
                                    name="description"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={addjob.addjobtopic}>
                                <h6>Add Invoice Details</h6>
                            </div>
                            <div className={addjob.addcontactdetails}>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice Name</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice name'
                                        name="invoiceName"
                                        value={formData.invoiceName}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice Country</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice country'
                                        name="invoiceCountry"
                                        value={formData.invoiceCountry}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice City</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice city'
                                        name="invoiceCity"
                                        value={formData.invoiceCity}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice Address</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the invoice address'
                                        name="invoiceAddress"
                                        value={formData.invoiceAddress}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Invoice PinCode</label>
                                    <input
                                        type="number"
                                        placeholder='Enter the invoice pinCode'
                                        name="invoicePinCode"
                                        value={formData.invoicePinCode}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Company Registration Number</label>
                                    <input
                                        type="text"
                                        placeholder='Enter the company registration number'
                                        name="companyRegistrationNumber"
                                        value={formData.companyRegistrationNumber}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Invoice Details</label>
                                <textarea placeholder='description'
                                    value={formData.invoiceDetails}
                                    name="invoiceDetails"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={addjob.addjobtopic}>
                                <h6>Select location from map</h6>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Map</label>
                                {/* Map component would go here */}
                            </div>
                        </div>
                        <div className={addjob.addjobbutton}>
                            <div className={addjob.rightbuttons}>
                                <button onClick={() => navigate(-1)}>Cancel</button>
                            </div>
                            <div className={addjob.rightbuttons}>
                                <button
                                    onClick={handleSubmit}
                                    style={{ background: '#F05423' }}
                                    disabled={loading}
                                >
                                    {loading ? "Adding..." : "Add"}
                                </button>
                            </div>
                        </div>
                    </div>

                )}
            </div>
        </>
    )
}

export default HOC(ReOrder)